import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlockCities, LazyBlockFindTariffs, LazyBlockHelp, LazyBlockOneClick, LazyBlockReviews, LazyCallMeProtect, LazyCallMeProtectNew, LazyCustomTags, LazyDBreadcrumbs, LazyDBtn, LazyDCustomRate, LazyDFooter, LazyDFooterNav, LazyDFooterPartner, LazyDHat, LazyDHatPartner, LazyDHatPartnerNew, LazyDHatPartnerSimple, LazyDHeaderB2B, LazyDHeaderDDProviders, LazyDHeaderDDTariffs, LazyDHeaderMobileB2B, LazyDHeaderMobileExtra, LazyDHeaderMobileMain, LazyDHeaderMobileMenu, LazyDHeaderMobileProviders, LazyDHeaderMobileTariffs, LazyDHeaderNew, LazyDHeaderPartner, LazyDHeaderPartnerNew, LazyDLogoHeader, LazyDMainLoader, LazyDOverFooter, LazyDSpinner, LazyDTextAreaPlaceholder, LazyEntryPageArea, LazyEntryPageMain, LazyEntryPageOrder, LazyEntryPageOrderNew, LazyEntryPagePTA, LazyEntryPagePersonal, LazyEntryPagePersonalNew, LazyEntryPagePersonalTag, LazyEntryPageRegionPTA, LazyEntryPageStatic, LazyMittModals, LazyModalAddressCheck, LazyModalAddressCheckAdditional, LazyModalAddressCheckB2B, LazyModalAddressCheckNew, LazyModalAddressCheckPartners, LazyModalCallMe, LazyModalCallMeAutomatLarge, LazyModalCallMeAutomatSmall, LazyModalCallMeAutomatSmallPartner, LazyModalCallMeAutomatization, LazyModalCallMeAutomatizationPartners, LazyModalCallMeDateTimePicker, LazyModalCallMePartners, LazyModalCallMeSegmentation, LazyModalCallMeSupport, LazyModalCallMeSupportOld, LazyModalCheckoutHelp, LazyModalCheckoutPartnersHelp, LazyModalCityChanged, LazyModalCityCheck, LazyModalCityCheckB2B, LazyModalDeviceAdd, LazyModalNew60sec, LazyModalNew60segmentation, LazyModalPartnersCallMe, LazyModalPartnersConsult, LazyModalPartnersCurrent, LazyModalPartnersCurrentConsult, LazyModalPartnersFastOrder, LazyModalPartnersFastSecondOrder, LazyModalPartnersMTCSupport, LazyModalPartnersNewCurrent, LazyModalPartnersSegmentation, LazyModalPartnersShortConsult, LazyModalPartnersSmallConsult, LazyModalPartnersSmallForm, LazyModalQuiz, LazyModalQuizConsultAddress, LazyModalQuizConsultDefault, LazyModalQuizConsultDefaultModal, LazyModalQuizConsultForm, LazyModalQuizConsultWrapper, LazyModalSpeedTestAllServers, LazyModalSpeedTestHistory, LazyModalStreetsSelect, LazyModalTariff, LazyModalTariffFastSecondOrder, LazyModalTariffOrder, LazyModalTariffOrderPatners, LazyModalTariffSegmentation, LazyModalVerification, LazyNSnackBar, LazyNewYear, LazyThatsWhy, LazyVCheckbox, LazyVCollapse, LazyVDateInput, LazyVDatePicker, LazyVDialog, LazyVDialogSheet, LazyVLazy, LazyVList, LazyVListItem, LazyVMenu, LazyVMobileDrawer, LazyVNTooltip, LazyVNotification, LazyVNotificationCard, LazyVPhoneInput, LazyVProgressCirc, LazyVRadio, LazyVRadioItem, LazyVRangeSlider, LazyVRating, LazyVSkeleton, LazyVSwiper, LazyVSwitch, LazyVTextInput, LazyVTooltip, LazyVScroll, LazyVScrollMore, LazyWantBestTariffs, LazyWantBestTariffsPartners, LazyWantBestTariffsProviders, LazyWantBestTariffsWhite, LazyBaseTsDBtn, LazyBaseTsInput, LazyAboutPagePartners, LazyAddressCheck, LazyAddressCheckSmall, LazyAddressCheckApartCheck, LazyAddressCheckSAPartnersCheck, LazyAddressCheckSearchAddressCheck, LazyBlogPageBlogContent, LazyBlogPageBlogHot, LazyBlogPageBlogMenu, LazyBlogPageBlogPreview, LazyBlogPageBlogPromo, LazyBlogPageBlogProvidersRating, LazyBlogPageBlogSimilarPosts, LazyBlogPageBlogSmallCard, LazyBlogPageBlogTable, LazyBlogPageBlogTariff, LazyBlogPageBlogWrap, LazyBusinessAutocomplete, LazyBusinessBenefits, LazyBusinessBestTariffs, LazyBusinessBlog, LazyBusinessHat, LazyBusinessHeaderMB, LazyBusinessHeaderPC, LazyBusinessHelper, LazyBusinessLoader, LazyBusinessLogo, LazyBusinessMobileMenu, LazyBusinessOrder, LazyBusinessProviders, LazyBusinessProvidersCard, LazyBusinessProvidersWrapper, LazyBusinessQuiz, LazyBusinessQuizAddress, LazyBusinessQuizClient, LazyBusinessQuizCompany, LazyBusinessQuizDefault, LazyBusinessSolutions, LazyBusinessSteps, LazyBusinessTariffCard, LazyBusinessTariffPicker, LazyBusinessTariffsHat, LazyBusinessTariffsWrapper, LazyBusinessText, LazyCareerFamiliarity, LazyCareerFooter, LazyCareerForm, LazyCareerHat, LazyCareerJoin, LazyCareerLast, LazyCareerOffer, LazyCareerPartners, LazyCareerPhoto, LazyCareerReviews, LazyCareerSteps, LazyCheckoutFooter, LazyCheckoutHeader, LazyCheckoutHeaderNew, LazyCheckoutOrder, LazyCheckoutPartnersHeader, LazyCheckoutPartnersOrder, LazyCheckoutPrice, LazyCompareHelp, LazyCompareItemHeader, LazyCookieMain, LazyCookiePageSettings, LazyCookieSettings, LazyCookieSnack, LazyDownDetectorDDComment, LazyDownDetectorDDComments, LazyDownDetectorDDCommentsForm, LazyDownDetectorDDModalNotWorking, LazyDownDetectorDDModalThanks, LazyDownDetectorDDProviderAbout, LazyDownDetectorDDProviderDayCrashes, LazyDownDetectorDDProviderFakeCard, LazyDownDetectorDDProviderGeo, LazyDownDetectorDDProviderSmallCard, LazyDownDetectorDDProviderText, LazyHelpCard, LazyHelpHeader, LazyHelpSide, LazyLocationsRegion, LazyMainPageCallMeBtn, LazyMainPageAbout, LazyMainPageBlog, LazyMainPageBlogSection, LazyMainPageCities, LazyMainPageCollect, LazyMainPageConnect, LazyMainPageHelp, LazyMainPageLatestConnected, LazyMainPageProviders, LazyMainPageMainProfitable, LazyMainPagePopularLargeTariffs, LazyMainPagePopularProviders, LazyMainPagePopularTariffs, LazyMainPageProvidersNewCarousel, LazyMainPageStreetText, LazyMainPageTariffsSuggestonNew, LazyOrderPageModalRate, LazyOrderPageAnotherOrders, LazyOrderPageCard, LazyOrderPageCardNew, LazyOrderPageCarousel, LazyOrderPageProgressLine, LazyPartnersActiveTariffs, LazyPartnersCallMeBtn, LazyPartnersCheckAvailability, LazyPartnersConsultModals, LazyPartnersEntryPageContacts, LazyPartnersEntryPageMain, LazyPartnersEntryPageMainNew, LazyPartnersEntryPageStaticPartners, LazyPartnersEntryPageTariffs, LazyPartnersEntryPageTariffsNew, LazyPartnersHatBenefits, LazyPartnersHowConnect, LazyPartnersMainBonus, LazyPartnersBestTariffs, LazyPartnersModal, LazyPartnersPageQuestion, LazyPartnersSearchForm, LazyPartnersPhoneBlock, LazyPartnersPromoSwiper, LazyPartnersSegmentationsModals, LazyPartnersTariffViewedPartners, LazyPartnersTariffsSuggestonPartners, LazyPartnersOrderAbout, LazyPartnersOrderAddress, LazyPartnersOrderContacts, LazyPartnersOrderDate, LazyPartnersOrderDevice, LazyPartnersOrderPrice, LazyPartnersOrderRouters, LazyPartnersOrderService, LazyPartnersOrderTariffs, LazyPartnersOrderTvBoxes, LazyPartnersOrderWrap, LazyPersonalProviders, LazyPersonalTariffsHelper, LazyProviderPagePromoSwiper, LazyProviderPageAbout, LazyProviderPageAboutPartner, LazyProviderPageBenefits, LazyProviderPageCheckaddress, LazyProviderPageCheckaddressPartner, LazyProviderPageContacts, LazyProviderPageDeviceCard, LazyProviderPageDevices, LazyProviderPageFastOrder, LazyProviderPageFooter, LazyProviderPageHeader, LazyProviderPageMain, LazyProviderPageMainPartner, LazyProviderPageReviewCard, LazyProviderPageReviews, LazyProviderPageProviderReviewsPage, LazyProviderPageProviderReviewsPagePartners, LazyProviderPageProvidersPageQuestion, LazyProvidersPageProvidersBestList, LazyProvidersPageProvidersCardNew, LazyProvidersPageProvidersCardNewLoading, LazyProvidersPageProvidersEnemyCard, LazyProvidersPageProvidersFastForm, LazyProvidersPageProvidersHelpBlock, LazyProvidersPageProvidersLargeCard, LazyProvidersPageProvidersLargeCardSkeleton, LazyProvidersPageProvidersNF, LazyProvidersPageProvidersSmallCard, LazyProvidersPageProvidersTable, LazyProvidersPageProvidersWrapper, LazyQuizBlock, LazyQuizModalLoader, LazyQuizResultFooter, LazyQuizTariff, LazyQuizTariffCard, LazyQuizTariffDevice, LazyRatingPageRatingCardFake, LazyRatingPageRatingCardMedium, LazyRatingPageRatingCardNew, LazyRatingPageRatingCardSmall, LazyRatingPageGlobalFast, LazyRatingPageTable, LazyRatingPageRatingText, LazyRatingPageRatingTopProviders, LazyRatingPageRatingTopProvidersCard, LazyRatingPageRatingTopProvidersGroup, LazyRatingPageRatingWrapperNew, LazyReviewsPageReviewsCard, LazyReviewsPageReviewsCardSkeleton, LazyReviewsPageReviewsComment, LazyReviewsPageReviewsComments, LazyReviewsPageReviewsLeaveComment, LazyReviewsPageReviewsLeaveReview, LazyReviewsPageReviewsLeaveReviewHorizontal, LazyReviewsPageReviewsMyReviews, LazyReviewsPageReviewsMyReviewsCard, LazyReviewsPageReviewsProviderCard, LazyReviewsPageReviewsProviderCarousel, LazyReviewsPageReviewsRateLine, LazyReviewsPageReviewsWrapper, LazySearchAddressPageSearchAddressCNA, LazySearchAddressPageSearchAddressFAQ, LazySearchAddressPageSearchAddressHouses, LazySearchAddressPageSearchAddressProviders, LazySearchAddressPageSearchAddressProvidersCover, LazySearchAddressPageSearchAddressProvidersNew, LazySearchAddressPageSearchAddressStepsLong, LazySearchAddressPageSearchAddressStepsShort, LazySeoPartnersFooter, LazySeoPartnersHeader, LazySeoPartnersPageContacts, LazySeoPartnersPageFAQ, LazySeoPartnersPageQuestion, LazySeoPartnersPageTariffs, LazySeoPartnersPageText, LazySeoPartnersSeoHat, LazySeoPartnersFormBestTariffs, LazySeoPartnersTariffCard, LazySeoPartnersTariffsFilter, LazySeoPartnersTariffsWrap, LazySpeedtestTariffs, LazySpeedtestStAbout, LazySpeedtestStCheck, LazySpeedtestStCheckCmd, LazySpeedtestStChecker, LazySpeedtestStCrushed, LazySpeedtestStEvening, LazySpeedtestStHeader, LazySpeedtestStHeaderOld, LazySpeedtestStPing, LazySpeedtestStRating, LazySpeedtestStRouter, LazySpeedtestStSpeed, LazySpeedtestStSpeedUp, LazySpeedtestStSpeedometer, LazySubscriptionsCard, LazySubscriptionsCardLoading, LazySubscriptionsServiceCard, LazySubscriptionsShowTariffs, LazySubscriptionsSubHeader, LazyTariffPageTariffCallMe, LazyTariffPageTariffCard, LazyTariffPageTariffDevice, LazyTariffPageTariffModalNA, LazyTariffPageTariffModalPrice, LazyTariffPageTariffProviderInfo, LazyTariffPageTariffViewed, LazyTariffsPageTariffsAddressWrapper, LazyTariffsPageTariffsCard, LazyTariffsPageTariffsCardHelp, LazyTariffsPageTariffsCardMedium, LazyTariffsPageTariffsCardNew, LazyTariffsPageTariffsCardParams, LazyTariffsPageTariffsCardSkeleton, LazyTariffsPageTariffsCardSmall, LazyTariffsPageTariffsCardXSmall, LazyTariffsPageTariffsFastConnection, LazyTariffsPageTariffsFilters, LazyTariffsPageTariffsGroup, LazyTariffsPageTariffsHelper, LazyTariffsPageTariffsLines, LazyTariffsPageTariffsLinesCard, LazyTariffsPageTariffsLinesGroup, LazyTariffsPageText, LazyTariffsPageTariffsServiceBtns, LazyTariffsPageTariffsSmartFilter, LazyTariffsPageTariffsTable, LazyTariffsPageTariffsText, LazyTariffsPageTariffsWrapper, LazyTariffsPageTariffsWrapperPartners, LazyTariffsPageTariffsWrapperProvider, LazyWidgetTariffsCarousel, LazyWidgetModals } from '#components'
const lazyGlobalComponents = [
  ["BlockCities", LazyBlockCities],
["BlockFindTariffs", LazyBlockFindTariffs],
["BlockHelp", LazyBlockHelp],
["BlockOneClick", LazyBlockOneClick],
["BlockReviews", LazyBlockReviews],
["CallMeProtect", LazyCallMeProtect],
["CallMeProtectNew", LazyCallMeProtectNew],
["CustomTags", LazyCustomTags],
["DBreadcrumbs", LazyDBreadcrumbs],
["DBtn", LazyDBtn],
["DCustomRate", LazyDCustomRate],
["DFooter", LazyDFooter],
["DFooterNav", LazyDFooterNav],
["DFooterPartner", LazyDFooterPartner],
["DHat", LazyDHat],
["DHatPartner", LazyDHatPartner],
["DHatPartnerNew", LazyDHatPartnerNew],
["DHatPartnerSimple", LazyDHatPartnerSimple],
["DHeaderB2B", LazyDHeaderB2B],
["DHeaderDDProviders", LazyDHeaderDDProviders],
["DHeaderDDTariffs", LazyDHeaderDDTariffs],
["DHeaderMobileB2B", LazyDHeaderMobileB2B],
["DHeaderMobileExtra", LazyDHeaderMobileExtra],
["DHeaderMobileMain", LazyDHeaderMobileMain],
["DHeaderMobileMenu", LazyDHeaderMobileMenu],
["DHeaderMobileProviders", LazyDHeaderMobileProviders],
["DHeaderMobileTariffs", LazyDHeaderMobileTariffs],
["DHeaderNew", LazyDHeaderNew],
["DHeaderPartner", LazyDHeaderPartner],
["DHeaderPartnerNew", LazyDHeaderPartnerNew],
["DLogoHeader", LazyDLogoHeader],
["DMainLoader", LazyDMainLoader],
["DOverFooter", LazyDOverFooter],
["DSpinner", LazyDSpinner],
["DTextAreaPlaceholder", LazyDTextAreaPlaceholder],
["EntryPageArea", LazyEntryPageArea],
["EntryPageMain", LazyEntryPageMain],
["EntryPageOrder", LazyEntryPageOrder],
["EntryPageOrderNew", LazyEntryPageOrderNew],
["EntryPagePTA", LazyEntryPagePTA],
["EntryPagePersonal", LazyEntryPagePersonal],
["EntryPagePersonalNew", LazyEntryPagePersonalNew],
["EntryPagePersonalTag", LazyEntryPagePersonalTag],
["EntryPageRegionPTA", LazyEntryPageRegionPTA],
["EntryPageStatic", LazyEntryPageStatic],
["MittModals", LazyMittModals],
["ModalAddressCheck", LazyModalAddressCheck],
["ModalAddressCheckAdditional", LazyModalAddressCheckAdditional],
["ModalAddressCheckB2B", LazyModalAddressCheckB2B],
["ModalAddressCheckNew", LazyModalAddressCheckNew],
["ModalAddressCheckPartners", LazyModalAddressCheckPartners],
["ModalCallMe", LazyModalCallMe],
["ModalCallMeAutomatLarge", LazyModalCallMeAutomatLarge],
["ModalCallMeAutomatSmall", LazyModalCallMeAutomatSmall],
["ModalCallMeAutomatSmallPartner", LazyModalCallMeAutomatSmallPartner],
["ModalCallMeAutomatization", LazyModalCallMeAutomatization],
["ModalCallMeAutomatizationPartners", LazyModalCallMeAutomatizationPartners],
["ModalCallMeDateTimePicker", LazyModalCallMeDateTimePicker],
["ModalCallMePartners", LazyModalCallMePartners],
["ModalCallMeSegmentation", LazyModalCallMeSegmentation],
["ModalCallMeSupport", LazyModalCallMeSupport],
["ModalCallMeSupportOld", LazyModalCallMeSupportOld],
["ModalCheckoutHelp", LazyModalCheckoutHelp],
["ModalCheckoutPartnersHelp", LazyModalCheckoutPartnersHelp],
["ModalCityChanged", LazyModalCityChanged],
["ModalCityCheck", LazyModalCityCheck],
["ModalCityCheckB2B", LazyModalCityCheckB2B],
["ModalDeviceAdd", LazyModalDeviceAdd],
["ModalNew60sec", LazyModalNew60sec],
["ModalNew60segmentation", LazyModalNew60segmentation],
["ModalPartnersCallMe", LazyModalPartnersCallMe],
["ModalPartnersConsult", LazyModalPartnersConsult],
["ModalPartnersCurrent", LazyModalPartnersCurrent],
["ModalPartnersCurrentConsult", LazyModalPartnersCurrentConsult],
["ModalPartnersFastOrder", LazyModalPartnersFastOrder],
["ModalPartnersFastSecondOrder", LazyModalPartnersFastSecondOrder],
["ModalPartnersMTCSupport", LazyModalPartnersMTCSupport],
["ModalPartnersNewCurrent", LazyModalPartnersNewCurrent],
["ModalPartnersSegmentation", LazyModalPartnersSegmentation],
["ModalPartnersShortConsult", LazyModalPartnersShortConsult],
["ModalPartnersSmallConsult", LazyModalPartnersSmallConsult],
["ModalPartnersSmallForm", LazyModalPartnersSmallForm],
["ModalQuiz", LazyModalQuiz],
["ModalQuizConsultAddress", LazyModalQuizConsultAddress],
["ModalQuizConsultDefault", LazyModalQuizConsultDefault],
["ModalQuizConsultDefaultModal", LazyModalQuizConsultDefaultModal],
["ModalQuizConsultForm", LazyModalQuizConsultForm],
["ModalQuizConsultWrapper", LazyModalQuizConsultWrapper],
["ModalSpeedTestAllServers", LazyModalSpeedTestAllServers],
["ModalSpeedTestHistory", LazyModalSpeedTestHistory],
["ModalStreetsSelect", LazyModalStreetsSelect],
["ModalTariff", LazyModalTariff],
["ModalTariffFastSecondOrder", LazyModalTariffFastSecondOrder],
["ModalTariffOrder", LazyModalTariffOrder],
["ModalTariffOrderPatners", LazyModalTariffOrderPatners],
["ModalTariffSegmentation", LazyModalTariffSegmentation],
["ModalVerification", LazyModalVerification],
["NSnackBar", LazyNSnackBar],
["NewYear", LazyNewYear],
["ThatsWhy", LazyThatsWhy],
["VCheckbox", LazyVCheckbox],
["VCollapse", LazyVCollapse],
["VDateInput", LazyVDateInput],
["VDatePicker", LazyVDatePicker],
["VDialog", LazyVDialog],
["VDialogSheet", LazyVDialogSheet],
["VLazy", LazyVLazy],
["VList", LazyVList],
["VListItem", LazyVListItem],
["VMenu", LazyVMenu],
["VMobileDrawer", LazyVMobileDrawer],
["VNTooltip", LazyVNTooltip],
["VNotification", LazyVNotification],
["VNotificationCard", LazyVNotificationCard],
["VPhoneInput", LazyVPhoneInput],
["VProgressCirc", LazyVProgressCirc],
["VRadio", LazyVRadio],
["VRadioItem", LazyVRadioItem],
["VRangeSlider", LazyVRangeSlider],
["VRating", LazyVRating],
["VSkeleton", LazyVSkeleton],
["VSwiper", LazyVSwiper],
["VSwitch", LazyVSwitch],
["VTextInput", LazyVTextInput],
["VTooltip", LazyVTooltip],
["VScroll", LazyVScroll],
["VScrollMore", LazyVScrollMore],
["WantBestTariffs", LazyWantBestTariffs],
["WantBestTariffsPartners", LazyWantBestTariffsPartners],
["WantBestTariffsProviders", LazyWantBestTariffsProviders],
["WantBestTariffsWhite", LazyWantBestTariffsWhite],
["BaseTsDBtn", LazyBaseTsDBtn],
["BaseTsInput", LazyBaseTsInput],
["AboutPagePartners", LazyAboutPagePartners],
["AddressCheck", LazyAddressCheck],
["AddressCheckSmall", LazyAddressCheckSmall],
["AddressCheckApartCheck", LazyAddressCheckApartCheck],
["AddressCheckSAPartnersCheck", LazyAddressCheckSAPartnersCheck],
["AddressCheckSearchAddressCheck", LazyAddressCheckSearchAddressCheck],
["BlogPageBlogContent", LazyBlogPageBlogContent],
["BlogPageBlogHot", LazyBlogPageBlogHot],
["BlogPageBlogMenu", LazyBlogPageBlogMenu],
["BlogPageBlogPreview", LazyBlogPageBlogPreview],
["BlogPageBlogPromo", LazyBlogPageBlogPromo],
["BlogPageBlogProvidersRating", LazyBlogPageBlogProvidersRating],
["BlogPageBlogSimilarPosts", LazyBlogPageBlogSimilarPosts],
["BlogPageBlogSmallCard", LazyBlogPageBlogSmallCard],
["BlogPageBlogTable", LazyBlogPageBlogTable],
["BlogPageBlogTariff", LazyBlogPageBlogTariff],
["BlogPageBlogWrap", LazyBlogPageBlogWrap],
["BusinessAutocomplete", LazyBusinessAutocomplete],
["BusinessBenefits", LazyBusinessBenefits],
["BusinessBestTariffs", LazyBusinessBestTariffs],
["BusinessBlog", LazyBusinessBlog],
["BusinessHat", LazyBusinessHat],
["BusinessHeaderMB", LazyBusinessHeaderMB],
["BusinessHeaderPC", LazyBusinessHeaderPC],
["BusinessHelper", LazyBusinessHelper],
["BusinessLoader", LazyBusinessLoader],
["BusinessLogo", LazyBusinessLogo],
["BusinessMobileMenu", LazyBusinessMobileMenu],
["BusinessOrder", LazyBusinessOrder],
["BusinessProviders", LazyBusinessProviders],
["BusinessProvidersCard", LazyBusinessProvidersCard],
["BusinessProvidersWrapper", LazyBusinessProvidersWrapper],
["BusinessQuiz", LazyBusinessQuiz],
["BusinessQuizAddress", LazyBusinessQuizAddress],
["BusinessQuizClient", LazyBusinessQuizClient],
["BusinessQuizCompany", LazyBusinessQuizCompany],
["BusinessQuizDefault", LazyBusinessQuizDefault],
["BusinessSolutions", LazyBusinessSolutions],
["BusinessSteps", LazyBusinessSteps],
["BusinessTariffCard", LazyBusinessTariffCard],
["BusinessTariffPicker", LazyBusinessTariffPicker],
["BusinessTariffsHat", LazyBusinessTariffsHat],
["BusinessTariffsWrapper", LazyBusinessTariffsWrapper],
["BusinessText", LazyBusinessText],
["CareerFamiliarity", LazyCareerFamiliarity],
["CareerFooter", LazyCareerFooter],
["CareerForm", LazyCareerForm],
["CareerHat", LazyCareerHat],
["CareerJoin", LazyCareerJoin],
["CareerLast", LazyCareerLast],
["CareerOffer", LazyCareerOffer],
["CareerPartners", LazyCareerPartners],
["CareerPhoto", LazyCareerPhoto],
["CareerReviews", LazyCareerReviews],
["CareerSteps", LazyCareerSteps],
["CheckoutFooter", LazyCheckoutFooter],
["CheckoutHeader", LazyCheckoutHeader],
["CheckoutHeaderNew", LazyCheckoutHeaderNew],
["CheckoutOrder", LazyCheckoutOrder],
["CheckoutPartnersHeader", LazyCheckoutPartnersHeader],
["CheckoutPartnersOrder", LazyCheckoutPartnersOrder],
["CheckoutPrice", LazyCheckoutPrice],
["CompareHelp", LazyCompareHelp],
["CompareItemHeader", LazyCompareItemHeader],
["CookieMain", LazyCookieMain],
["CookiePageSettings", LazyCookiePageSettings],
["CookieSettings", LazyCookieSettings],
["CookieSnack", LazyCookieSnack],
["DownDetectorDDComment", LazyDownDetectorDDComment],
["DownDetectorDDComments", LazyDownDetectorDDComments],
["DownDetectorDDCommentsForm", LazyDownDetectorDDCommentsForm],
["DownDetectorDDModalNotWorking", LazyDownDetectorDDModalNotWorking],
["DownDetectorDDModalThanks", LazyDownDetectorDDModalThanks],
["DownDetectorDDProviderAbout", LazyDownDetectorDDProviderAbout],
["DownDetectorDDProviderDayCrashes", LazyDownDetectorDDProviderDayCrashes],
["DownDetectorDDProviderFakeCard", LazyDownDetectorDDProviderFakeCard],
["DownDetectorDDProviderGeo", LazyDownDetectorDDProviderGeo],
["DownDetectorDDProviderSmallCard", LazyDownDetectorDDProviderSmallCard],
["DownDetectorDDProviderText", LazyDownDetectorDDProviderText],
["HelpCard", LazyHelpCard],
["HelpHeader", LazyHelpHeader],
["HelpSide", LazyHelpSide],
["LocationsRegion", LazyLocationsRegion],
["MainPageCallMeBtn", LazyMainPageCallMeBtn],
["MainPageAbout", LazyMainPageAbout],
["MainPageBlog", LazyMainPageBlog],
["MainPageBlogSection", LazyMainPageBlogSection],
["MainPageCities", LazyMainPageCities],
["MainPageCollect", LazyMainPageCollect],
["MainPageConnect", LazyMainPageConnect],
["MainPageHelp", LazyMainPageHelp],
["MainPageLatestConnected", LazyMainPageLatestConnected],
["MainPageProviders", LazyMainPageProviders],
["MainPageMainProfitable", LazyMainPageMainProfitable],
["MainPagePopularLargeTariffs", LazyMainPagePopularLargeTariffs],
["MainPagePopularProviders", LazyMainPagePopularProviders],
["MainPagePopularTariffs", LazyMainPagePopularTariffs],
["MainPageProvidersNewCarousel", LazyMainPageProvidersNewCarousel],
["MainPageStreetText", LazyMainPageStreetText],
["MainPageTariffsSuggestonNew", LazyMainPageTariffsSuggestonNew],
["OrderPageModalRate", LazyOrderPageModalRate],
["OrderPageAnotherOrders", LazyOrderPageAnotherOrders],
["OrderPageCard", LazyOrderPageCard],
["OrderPageCardNew", LazyOrderPageCardNew],
["OrderPageCarousel", LazyOrderPageCarousel],
["OrderPageProgressLine", LazyOrderPageProgressLine],
["PartnersActiveTariffs", LazyPartnersActiveTariffs],
["PartnersCallMeBtn", LazyPartnersCallMeBtn],
["PartnersCheckAvailability", LazyPartnersCheckAvailability],
["PartnersConsultModals", LazyPartnersConsultModals],
["PartnersEntryPageContacts", LazyPartnersEntryPageContacts],
["PartnersEntryPageMain", LazyPartnersEntryPageMain],
["PartnersEntryPageMainNew", LazyPartnersEntryPageMainNew],
["PartnersEntryPageStaticPartners", LazyPartnersEntryPageStaticPartners],
["PartnersEntryPageTariffs", LazyPartnersEntryPageTariffs],
["PartnersEntryPageTariffsNew", LazyPartnersEntryPageTariffsNew],
["PartnersHatBenefits", LazyPartnersHatBenefits],
["PartnersHowConnect", LazyPartnersHowConnect],
["PartnersMainBonus", LazyPartnersMainBonus],
["PartnersBestTariffs", LazyPartnersBestTariffs],
["PartnersModal", LazyPartnersModal],
["PartnersPageQuestion", LazyPartnersPageQuestion],
["PartnersSearchForm", LazyPartnersSearchForm],
["PartnersPhoneBlock", LazyPartnersPhoneBlock],
["PartnersPromoSwiper", LazyPartnersPromoSwiper],
["PartnersSegmentationsModals", LazyPartnersSegmentationsModals],
["PartnersTariffViewedPartners", LazyPartnersTariffViewedPartners],
["PartnersTariffsSuggestonPartners", LazyPartnersTariffsSuggestonPartners],
["PartnersOrderAbout", LazyPartnersOrderAbout],
["PartnersOrderAddress", LazyPartnersOrderAddress],
["PartnersOrderContacts", LazyPartnersOrderContacts],
["PartnersOrderDate", LazyPartnersOrderDate],
["PartnersOrderDevice", LazyPartnersOrderDevice],
["PartnersOrderPrice", LazyPartnersOrderPrice],
["PartnersOrderRouters", LazyPartnersOrderRouters],
["PartnersOrderService", LazyPartnersOrderService],
["PartnersOrderTariffs", LazyPartnersOrderTariffs],
["PartnersOrderTvBoxes", LazyPartnersOrderTvBoxes],
["PartnersOrderWrap", LazyPartnersOrderWrap],
["PersonalProviders", LazyPersonalProviders],
["PersonalTariffsHelper", LazyPersonalTariffsHelper],
["ProviderPagePromoSwiper", LazyProviderPagePromoSwiper],
["ProviderPageAbout", LazyProviderPageAbout],
["ProviderPageAboutPartner", LazyProviderPageAboutPartner],
["ProviderPageBenefits", LazyProviderPageBenefits],
["ProviderPageCheckaddress", LazyProviderPageCheckaddress],
["ProviderPageCheckaddressPartner", LazyProviderPageCheckaddressPartner],
["ProviderPageContacts", LazyProviderPageContacts],
["ProviderPageDeviceCard", LazyProviderPageDeviceCard],
["ProviderPageDevices", LazyProviderPageDevices],
["ProviderPageFastOrder", LazyProviderPageFastOrder],
["ProviderPageFooter", LazyProviderPageFooter],
["ProviderPageHeader", LazyProviderPageHeader],
["ProviderPageMain", LazyProviderPageMain],
["ProviderPageMainPartner", LazyProviderPageMainPartner],
["ProviderPageReviewCard", LazyProviderPageReviewCard],
["ProviderPageReviews", LazyProviderPageReviews],
["ProviderPageProviderReviewsPage", LazyProviderPageProviderReviewsPage],
["ProviderPageProviderReviewsPagePartners", LazyProviderPageProviderReviewsPagePartners],
["ProviderPageProvidersPageQuestion", LazyProviderPageProvidersPageQuestion],
["ProvidersPageProvidersBestList", LazyProvidersPageProvidersBestList],
["ProvidersPageProvidersCardNew", LazyProvidersPageProvidersCardNew],
["ProvidersPageProvidersCardNewLoading", LazyProvidersPageProvidersCardNewLoading],
["ProvidersPageProvidersEnemyCard", LazyProvidersPageProvidersEnemyCard],
["ProvidersPageProvidersFastForm", LazyProvidersPageProvidersFastForm],
["ProvidersPageProvidersHelpBlock", LazyProvidersPageProvidersHelpBlock],
["ProvidersPageProvidersLargeCard", LazyProvidersPageProvidersLargeCard],
["ProvidersPageProvidersLargeCardSkeleton", LazyProvidersPageProvidersLargeCardSkeleton],
["ProvidersPageProvidersNF", LazyProvidersPageProvidersNF],
["ProvidersPageProvidersSmallCard", LazyProvidersPageProvidersSmallCard],
["ProvidersPageProvidersTable", LazyProvidersPageProvidersTable],
["ProvidersPageProvidersWrapper", LazyProvidersPageProvidersWrapper],
["QuizBlock", LazyQuizBlock],
["QuizModalLoader", LazyQuizModalLoader],
["QuizResultFooter", LazyQuizResultFooter],
["QuizTariff", LazyQuizTariff],
["QuizTariffCard", LazyQuizTariffCard],
["QuizTariffDevice", LazyQuizTariffDevice],
["RatingPageRatingCardFake", LazyRatingPageRatingCardFake],
["RatingPageRatingCardMedium", LazyRatingPageRatingCardMedium],
["RatingPageRatingCardNew", LazyRatingPageRatingCardNew],
["RatingPageRatingCardSmall", LazyRatingPageRatingCardSmall],
["RatingPageGlobalFast", LazyRatingPageGlobalFast],
["RatingPageTable", LazyRatingPageTable],
["RatingPageRatingText", LazyRatingPageRatingText],
["RatingPageRatingTopProviders", LazyRatingPageRatingTopProviders],
["RatingPageRatingTopProvidersCard", LazyRatingPageRatingTopProvidersCard],
["RatingPageRatingTopProvidersGroup", LazyRatingPageRatingTopProvidersGroup],
["RatingPageRatingWrapperNew", LazyRatingPageRatingWrapperNew],
["ReviewsPageReviewsCard", LazyReviewsPageReviewsCard],
["ReviewsPageReviewsCardSkeleton", LazyReviewsPageReviewsCardSkeleton],
["ReviewsPageReviewsComment", LazyReviewsPageReviewsComment],
["ReviewsPageReviewsComments", LazyReviewsPageReviewsComments],
["ReviewsPageReviewsLeaveComment", LazyReviewsPageReviewsLeaveComment],
["ReviewsPageReviewsLeaveReview", LazyReviewsPageReviewsLeaveReview],
["ReviewsPageReviewsLeaveReviewHorizontal", LazyReviewsPageReviewsLeaveReviewHorizontal],
["ReviewsPageReviewsMyReviews", LazyReviewsPageReviewsMyReviews],
["ReviewsPageReviewsMyReviewsCard", LazyReviewsPageReviewsMyReviewsCard],
["ReviewsPageReviewsProviderCard", LazyReviewsPageReviewsProviderCard],
["ReviewsPageReviewsProviderCarousel", LazyReviewsPageReviewsProviderCarousel],
["ReviewsPageReviewsRateLine", LazyReviewsPageReviewsRateLine],
["ReviewsPageReviewsWrapper", LazyReviewsPageReviewsWrapper],
["SearchAddressPageSearchAddressCNA", LazySearchAddressPageSearchAddressCNA],
["SearchAddressPageSearchAddressFAQ", LazySearchAddressPageSearchAddressFAQ],
["SearchAddressPageSearchAddressHouses", LazySearchAddressPageSearchAddressHouses],
["SearchAddressPageSearchAddressProviders", LazySearchAddressPageSearchAddressProviders],
["SearchAddressPageSearchAddressProvidersCover", LazySearchAddressPageSearchAddressProvidersCover],
["SearchAddressPageSearchAddressProvidersNew", LazySearchAddressPageSearchAddressProvidersNew],
["SearchAddressPageSearchAddressStepsLong", LazySearchAddressPageSearchAddressStepsLong],
["SearchAddressPageSearchAddressStepsShort", LazySearchAddressPageSearchAddressStepsShort],
["SeoPartnersFooter", LazySeoPartnersFooter],
["SeoPartnersHeader", LazySeoPartnersHeader],
["SeoPartnersPageContacts", LazySeoPartnersPageContacts],
["SeoPartnersPageFAQ", LazySeoPartnersPageFAQ],
["SeoPartnersPageQuestion", LazySeoPartnersPageQuestion],
["SeoPartnersPageTariffs", LazySeoPartnersPageTariffs],
["SeoPartnersPageText", LazySeoPartnersPageText],
["SeoPartnersSeoHat", LazySeoPartnersSeoHat],
["SeoPartnersFormBestTariffs", LazySeoPartnersFormBestTariffs],
["SeoPartnersTariffCard", LazySeoPartnersTariffCard],
["SeoPartnersTariffsFilter", LazySeoPartnersTariffsFilter],
["SeoPartnersTariffsWrap", LazySeoPartnersTariffsWrap],
["SpeedtestTariffs", LazySpeedtestTariffs],
["SpeedtestStAbout", LazySpeedtestStAbout],
["SpeedtestStCheck", LazySpeedtestStCheck],
["SpeedtestStCheckCmd", LazySpeedtestStCheckCmd],
["SpeedtestStChecker", LazySpeedtestStChecker],
["SpeedtestStCrushed", LazySpeedtestStCrushed],
["SpeedtestStEvening", LazySpeedtestStEvening],
["SpeedtestStHeader", LazySpeedtestStHeader],
["SpeedtestStHeaderOld", LazySpeedtestStHeaderOld],
["SpeedtestStPing", LazySpeedtestStPing],
["SpeedtestStRating", LazySpeedtestStRating],
["SpeedtestStRouter", LazySpeedtestStRouter],
["SpeedtestStSpeed", LazySpeedtestStSpeed],
["SpeedtestStSpeedUp", LazySpeedtestStSpeedUp],
["SpeedtestStSpeedometer", LazySpeedtestStSpeedometer],
["SubscriptionsCard", LazySubscriptionsCard],
["SubscriptionsCardLoading", LazySubscriptionsCardLoading],
["SubscriptionsServiceCard", LazySubscriptionsServiceCard],
["SubscriptionsShowTariffs", LazySubscriptionsShowTariffs],
["SubscriptionsSubHeader", LazySubscriptionsSubHeader],
["TariffPageTariffCallMe", LazyTariffPageTariffCallMe],
["TariffPageTariffCard", LazyTariffPageTariffCard],
["TariffPageTariffDevice", LazyTariffPageTariffDevice],
["TariffPageTariffModalNA", LazyTariffPageTariffModalNA],
["TariffPageTariffModalPrice", LazyTariffPageTariffModalPrice],
["TariffPageTariffProviderInfo", LazyTariffPageTariffProviderInfo],
["TariffPageTariffViewed", LazyTariffPageTariffViewed],
["TariffsPageTariffsAddressWrapper", LazyTariffsPageTariffsAddressWrapper],
["TariffsPageTariffsCard", LazyTariffsPageTariffsCard],
["TariffsPageTariffsCardHelp", LazyTariffsPageTariffsCardHelp],
["TariffsPageTariffsCardMedium", LazyTariffsPageTariffsCardMedium],
["TariffsPageTariffsCardNew", LazyTariffsPageTariffsCardNew],
["TariffsPageTariffsCardParams", LazyTariffsPageTariffsCardParams],
["TariffsPageTariffsCardSkeleton", LazyTariffsPageTariffsCardSkeleton],
["TariffsPageTariffsCardSmall", LazyTariffsPageTariffsCardSmall],
["TariffsPageTariffsCardXSmall", LazyTariffsPageTariffsCardXSmall],
["TariffsPageTariffsFastConnection", LazyTariffsPageTariffsFastConnection],
["TariffsPageTariffsFilters", LazyTariffsPageTariffsFilters],
["TariffsPageTariffsGroup", LazyTariffsPageTariffsGroup],
["TariffsPageTariffsHelper", LazyTariffsPageTariffsHelper],
["TariffsPageTariffsLines", LazyTariffsPageTariffsLines],
["TariffsPageTariffsLinesCard", LazyTariffsPageTariffsLinesCard],
["TariffsPageTariffsLinesGroup", LazyTariffsPageTariffsLinesGroup],
["TariffsPageText", LazyTariffsPageText],
["TariffsPageTariffsServiceBtns", LazyTariffsPageTariffsServiceBtns],
["TariffsPageTariffsSmartFilter", LazyTariffsPageTariffsSmartFilter],
["TariffsPageTariffsTable", LazyTariffsPageTariffsTable],
["TariffsPageTariffsText", LazyTariffsPageTariffsText],
["TariffsPageTariffsWrapper", LazyTariffsPageTariffsWrapper],
["TariffsPageTariffsWrapperPartners", LazyTariffsPageTariffsWrapperPartners],
["TariffsPageTariffsWrapperProvider", LazyTariffsPageTariffsWrapperProvider],
["WidgetTariffsCarousel", LazyWidgetTariffsCarousel],
["WidgetModals", LazyWidgetModals],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
